import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { PathBuilder, RequestTypes, axiosBaseQuery } from "../../utils";
import {
  IMedicalCardQualification,
  IMedicalCardsHistoryResponse,
  IMessageResponse,
  credential,
  SortingOrders,
  SortingFields,
} from "../../shared";

export const MEDICAL_CARD_API_REDUCER_KEY = "medicalCardApi";

export const medicalCardApi = createApi({
  reducerPath: MEDICAL_CARD_API_REDUCER_KEY,
  baseQuery: axiosBaseQuery({
    baseUrl: credential.apiUrl as string,
  }),
  tagTypes: [MEDICAL_CARD_API_REDUCER_KEY],
  endpoints: (build) => ({
    createMedicalCard: build.mutation<IMessageResponse, FormData>({
      query: (params) => ({
        url: PathBuilder.medicalCardApi.createMedicalCard(),
        method: RequestTypes.post,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: params,
      }),
      invalidatesTags: [MEDICAL_CARD_API_REDUCER_KEY],
    }),
    updateMedicalCard: build.mutation<
      IMedicalCardQualification,
      { params: FormData; _id: string }
    >({
      query: (data) => {
        const { params, _id } = data;

        return {
          url: PathBuilder.medicalCardApi.updateMedicalCard(_id),
          method: RequestTypes.put,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: params,
        };
      },
      invalidatesTags: [MEDICAL_CARD_API_REDUCER_KEY],
    }),
    fetchPatientMedicalCardList: build.query<
      IMedicalCardsHistoryResponse,
      {
        patientId: string;
        sortField: SortingFields;
        sortOrder: SortingOrders;
        limit: number;
        page: number;
      }
    >({
      query: (params) => ({
        url: PathBuilder.medicalCardApi.fetchPatientMedicalCardList(
          params.patientId,
        ),
        method: RequestTypes.get,
        params: {
          sortField: params.sortField,
          sortOrder: params.sortOrder,
          limit: params.limit,
          page: params.page,
        },
      }),
      providesTags: () => [MEDICAL_CARD_API_REDUCER_KEY],
    }),
    fetchPatientMedicalCard: build.query<IMedicalCardQualification, string>({
      query: (medicalCardId) => ({
        url: PathBuilder.medicalCardApi.fetchPatientMedicalCard(medicalCardId),
        method: RequestTypes.get,
      }),
      providesTags: () => [MEDICAL_CARD_API_REDUCER_KEY],
    }),
    downloadMedicalCard: build.mutation<
      { blob: Blob; filename: string },
      { id: string; fallbackFilename?: string }
    >({
      query: ({ id, fallbackFilename }) => ({
        url: PathBuilder.medicalCardApi.downloadMedicalCard(id),
        method: RequestTypes.get,
        responseType: "blob",
        fallbackFilename,
      }),
    }),
  }),
});
